import script from "./PauseDelivery.vue?vue&type=script&setup=true&lang=js"
export * from "./PauseDelivery.vue?vue&type=script&setup=true&lang=js"

import "./PauseDelivery.vue?vue&type=style&index=0&id=2dec738d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dec738d"]])

export default __exports__